export const replaceQueryWindowHistoryState = (query: string): void => {
  if (typeof window !== 'undefined') {
    if (query.length > 0) window.history.replaceState({}, '', `${window.location.pathname}${query}`);
    else window.history.replaceState(null, '', window.location.pathname);
  }
};
